import React from 'react';
import { customerApi } from '../services/api';

/**
 * CustomerAvatar
 * Shows the customer's profile image (if uploaded) as a circular thumbnail,
 * else falls back to colored initials.
 *
 * Usage:
 *   <CustomerAvatar customer={c} size={32} />
 */
const colorFromString = (s) => {
  let h = 0;
  for (let i = 0; i < (s || '').length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  const hue = h % 360;
  return `hsl(${hue} 60% 45%)`;
};

const CustomerAvatar = ({ customer, size = 32, className = '', authVersion = 0 }) => {
  if (!customer) return null;
  const name = `${customer.first_name || ''} ${customer.last_name || ''}`.trim();
  const initials = (
    (customer.first_name || '?').charAt(0) + (customer.last_name || '').charAt(0)
  ).toUpperCase();
  const hasImage = !!customer.profile_image?.id;
  const url = hasImage
    ? `${customerApi.documentUrl(customer.id, 'profile')}?v=${customer.profile_image.id}`
    : null;

  const style = {
    width: size,
    height: size,
    minWidth: size,
    backgroundColor: colorFromString(name || customer.id || 'X'),
  };

  return (
    <div
      className={`rounded-full overflow-hidden flex items-center justify-center text-white font-semibold ${className}`}
      style={style}
      title={name}
      data-testid="customer-avatar"
    >
      {hasImage ? (
        <img
          src={url}
          alt={name}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      ) : (
        <span style={{ fontSize: Math.round(size * 0.4) }}>{initials}</span>
      )}
    </div>
  );
};

export default CustomerAvatar;
